import { EventRegistryCategory } from '../../../registry/event/EventRegistryCategory';
import { EventRegistryItem } from '../../../registry/event/EventRegistryItem';
export class EventsMultipleChoice extends EventRegistryCategory {
    label = 'Multiple Choice';
    constructor(parent) {
        super(parent);
        super.init();
    }
    optionwasselected = () => new EventRegistryItem({ handlerName: 'onOptionWasSelected' });
    failedtry = () => new EventRegistryItem({ handlerName: 'onFailedTry' });
}
